import { render, staticRenderFns } from "./SearchResultSection.vue?vue&type=template&id=d4780e46&scoped=true&"
import script from "./SearchResultSection.vue?vue&type=script&lang=js&"
export * from "./SearchResultSection.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultSection.vue?vue&type=style&index=0&id=d4780e46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4780e46",
  null
  
)

export default component.exports